/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Instagram/theme';

export const InstagramTheme = theme;
